import { render, staticRenderFns } from "./ChatPopupNotifications.vue?vue&type=template&id=41fb9d08&scoped=true"
import script from "./ChatPopupNotifications.vue?vue&type=script&lang=ts"
export * from "./ChatPopupNotifications.vue?vue&type=script&lang=ts"
import style0 from "./ChatPopupNotifications.vue?vue&type=style&index=0&id=41fb9d08&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb9d08",
  null
  
)

export default component.exports